import { useState, useEffect } from 'react';

export const useDuplicateAlert = count => {
  const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);

  function closeDuplicateAlert() {
    setShowDuplicateAlert(false);
  }

  useEffect(() => {
    setShowDuplicateAlert(!!count);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  return {
    showDuplicateAlert,
    closeDuplicateAlert
  };
};
